import { gql } from "@apollo/client";

export const groupEnrollmentRestrictionsMutation = gql`
  mutation groupEnrollmentRestrictions(
    $scenarioId: ID!
    $originId: ID!
    $input: GroupEnrollmentRestrictionsInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      groupEnrollmentRestrictions(input: $input) {
        group {
          id
          code
          groupEnrollmentRestrictions {
            table
            attribute
            valueIds
            operator
            values {
              __typename
              ... on CustomModelValue {
                id
                customModelValueCode: code
                customModelValueValue: value
                customModel {
                  id
                  code
                  name
                }
                __typename
              }
              ... on Modality {
                id
                modalityCode: code
                modalityName: name
                __typename
              }
              ... on Campus {
                id
                campusCode: code
                campusName: name
                __typename
              }
              ... on Program {
                id
                programCode: code
                programName: name
                __typename
              }
              ... on Curriculum {
                id
                curriculumCode: code
                curriculumName: name
                __typename
              }
            }
          }
        }
        commited
        validationErrors {
          __typename
          ... on InvalidFieldValidation {
            value
            reason
            meta
          }
        }
      }
    }
  }
`;
